import { render } from "./new_Survey.vue?vue&type=template&id=23947449&scoped=true"
import script from "./new_Survey.vue?vue&type=script&lang=js"
export * from "./new_Survey.vue?vue&type=script&lang=js"

import "./new_Survey.vue?vue&type=style&index=0&id=23947449&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23947449"]])

export default __exports__